import OnboardingCard from './onboarding-card';

export default OnboardingCard;
